import React, { Component, PropsWithChildren } from 'react';

import styled from 'styled-components';

import Box from '../atoms/Box/Box';

type SelectBoxProps = {
  className?: string;
  color: string;
  onClick: () => void;
  pt?: number;
  pb?: number;
  mb?: number;
};

class SelectBox extends Component<PropsWithChildren<SelectBoxProps>> {
  static defaultProps = {
    color: 'scarpaFlow',
  };

  render() {
    const { color, children, ...props } = this.props;

    return <Box {...props}>{children}</Box>;
  }
}

const styledSelectBox = styled(SelectBox)`
  cursor: pointer;
  background-color: ${props => props.theme.colors.white};
  transition-property: all;
  transition-duration: 0.25s;
  transition-timing-function: ease-in-out;
  overflow: hidden;
  color: ${props => props.theme.colors[props.color]};
`;

export default styledSelectBox;
